<jjames-card>
    <div class="p-6 text-center">
        <mat-icon class="text-green-500" style="font-size: 48px; width: 48px; height: 48px;">check_circle</mat-icon>
        <h2 class="text-2xl font-semibold text-gray-800 mt-4 mb-2">Parking Space Created!</h2>
        <p class="text-gray-600 mb-6">
            The parking space <strong>{{ parkingSpace.name }}</strong> has been successfully created.
        </p>

        <div class="text-left space-y-4 max-w-md mx-auto">
            <!-- Infrastructure Summary -->
            @if (infrastructure) {
            <div class="p-4 border rounded-lg">
                <h3 class="font-semibold text-lg mb-2">Infrastructure Summary</h3>
                <p><strong>ID:</strong> {{ infrastructure.id }}</p>
            </div>
            }

            <!-- Device Groups Summary -->
            @if (deviceGroups && deviceGroups.length > 0) {
            <div class="p-4 border rounded-lg">
                <h3 class="font-semibold text-lg mb-2">Device Groups Created</h3>
                <mat-list>
                    @for (group of deviceGroups; track group.id) {
                    <mat-list-item>
                        <mat-icon matListItemIcon>router</mat-icon>
                        <div matListItemTitle>{{ group.groupName }}</div>
                        <div matListItemLine>{{ group.groupDescription }}</div>
                    </mat-list-item>
                    }
                </mat-list>
            </div>
            }
        </div>

        <p class="text-sm text-gray-500 mt-6">
            You can now proceed to configure the devices for the created device groups.
        </p>

        <!-- Actions -->
        <div class="flex justify-center mt-8">
            <button type="button" mat-flat-button color="primary" (click)="onFinish()">
                Finish and Go to Details
            </button>
        </div>
    </div>
</jjames-card>